import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import "./index.css";
import { jsx } from 'react/jsx-runtime';
import { CheckboxField } from '@design-system/checkbox-field';
import { getQueries } from '@promo-platform/utils';
import { forwardRef } from 'react';
import { useQueries } from 'react-query';
import axios from 'axios';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
var DEFAULT_URL = 'https://digital-lds-application-web-production.frankfurt.rbdigitalcloud.com';
var fetchLds = function fetchLds(businessId) {
  var baseURL = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_URL;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response, _response$data$result, _response$data$result2, revisionId, body, customName;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return axios.get("/r/document/".concat(businessId), {
              baseURL: baseURL,
              params: {
                bodyContentType: 'html'
              }
            });
          case 3:
            response = _context.sent;
            _response$data$result = response.data.result, _response$data$result2 = _response$data$result.publishedPeriod.latestRevision, revisionId = _response$data$result2._id, body = _response$data$result2.body, customName = _response$data$result.customName;
            return _context.abrupt("return", {
              revisionId: revisionId,
              documentId: businessId,
              name: customName,
              body: body
            });
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            console.log('Error on fetch lds content', _context.t0);
            return _context.abrupt("return", null);
          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 8]]);
  }));
};
var LegalField = forwardRef(function (_a, ref) {
  var description = _a.description,
    config = _a.config,
    rest = __rest(_a, ["description", "config"]);
  var queries = getQueries(description);
  useQueries(queries.map(function (lds) {
    return {
      queryKey: [lds.data.legalDocumentId],
      queryFn: function queryFn() {
        return fetchLds(lds.data.legalDocumentId, config === null || config === void 0 ? void 0 : config.healthBaseUrl);
      }
    };
  }));
  return jsx(CheckboxField, Object.assign({
    ref: ref,
    description: description,
    className: "cds-legal-field"
  }, rest));
});
export { LegalField };